define('GameDayCore/GDModel/ValueObjects/Scoreboard/AllInnings',['require','exports','module','../ValueObjectFactory','../../../GDControl/GameModelLocator/GameModelLocator','./Innings'],function(require, exports, module) {
	var VO = require('../ValueObjectFactory'),
        GameModelLocator = require("../../../GDControl/GameModelLocator/GameModelLocator"),
        InningsVO = require("./Innings");

	VO.create(AllInnings);

	function AllInnings ($data) {
		var vo = VO.ensureVO(this, AllInnings),
			data = $data,
			inning = $data instanceof InningsVO ? $data : new InningsVO($data),
			ALL_INNINGS = 'all_innings',
			innings = GameModelLocator.getGameData(ALL_INNINGS)[ALL_INNINGS];
		
		vo.innings = innings && innings.innings || [];

		if(vo.innings) {
			var i = 0,
				num = ~~(inning.num),
				len = vo.innings.length;

			vo.innings[num -1] = inning;
			for (; i < len; i++) {
				vo.innings[i] = vo.innings[i] || {num: i + 1};
			}
		}
	}

	return AllInnings;
});
